const useSSearchInputStyles = () => {
    return {
        searchbarStyles: {
            gap: 1,
            borderRadius: '50px',
            backgroundColor: '#919EAB14',
            // border: '1px solid #919EAB33',
            '&:hover': {
                backgroundColor: '#919EAB14',
            },
            '&.Mui-focused': {
                backgroundColor: '#919EAB14',
            },
        },
    };
};
export default useSSearchInputStyles;
